<script>
import { download } from '@/found/utils/index.js';
import TablePage from '../../../../../components/table_page';
import request, { portUrl } from '../../../../../utils/request';
import ExportModal from '../../../../../components/export_modal';

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    ExportModal,
  },
  data() {
    return {
      formConfig: {},
      requestType: 'POST',
      modalConfig: {
        title: '查看附件',
        visible: false,
        type: '',
      },
      options: [],
    };
  },
  async created() {
    await this.getConfigList('main_list');
  },
  methods: {
    async getDict() {
      const resData = await request.get('/mdm/mdmdictdata/dictTree', {
        dictTypeCode: 'file_type',
      });
      this.options = resData.result;
    },
    clickVisible({ row, val: { code } }) {
      if (code === 'source_file') {
        return row.taskStatus >= '3';
      }
      if (code === 'failure_file') {
        return row.taskStatus === 8;
      }
      if (code === 'processed') {
        return [2, 5, 8, 9].includes(row.taskStatus) && row.handleStatus === 0;
      }
      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'source_file') {
        download(row.fileUrl);
      } else if (val.code === 'failure_file') {
        download(row.errorFileUrl);
      } else if (val.code === 'processed') {
        request.post('/tax/v1/terminalCash/api/handleErorrStatus', row).then((res) => {
          if (res.success) {
            this.$message.success('处理成功');
            this.getList();
          }
        });
      }
    },
    // 查看进度
    prograssClick({ val, row }) {
      this.modalName = 'ExportModal';
      let fileParam = {};
      let configCode = '';
      if (row.fileType === '0') {
        configCode = row.fileParam;
        fileParam.sid = row.webSocketId;
      } else {
        fileParam = JSON.parse(row.fileParam);
      }
      this.propsObjInData = {
        code: val.code,
        row,
        ...fileParam,
        configCode,
        visible: true,
        exportMessage: '',
        isExport: row.fileType !== '0',
      };
    },
  },
};
</script>
